import { HttpContextToken } from '@angular/common/http';

export const DEFAULT_STALE_TIME = 300_000; // 5 minutes

export const CACHE_KEY_SYMBOL = Symbol('CacheKey');

/**
 * Affects the amount of time a query will be considered fresh
 * If a query is fresh, its cached data will be returned instead of making a network request
 */
export const STALE_TIME = new HttpContextToken<number>(() => DEFAULT_STALE_TIME);

/**
 * If set to true, the cache will be skipped for this request.
 * This also includes any sort of automated invalidation, cleanup and caching
 */
export const SKIP_CACHE = new HttpContextToken<boolean>(() => false);
